import * as types from '../types/wall'

import createReducer from '../createReducer'

const initialState = {
  isFetchingWalls: false,
  isFetchingNodeInfo: false,
  isSendingEvent: false,
  data: {},
  errors: {},
}

export default createReducer(initialState, {
  [types.ADD_WALL](state, action) {
    const { wall } = action

    if (!wall) return state
    if (!state.data?.ticketId) return state
    if (wall.ticketId !== state.data.ticketId) return state

    return { ...state, data: wall }
  },
  [types.ADD_NODE](state, action) {
    const { node } = action

    if (!node) return state
    if (node.user !== state.data.ticketId) return state

    return {
      ...state,
      data: {
        ...state.data,
        nodeInfos: [node, ...state.data.nodeInfos],
      },
    }
  },
  [types.UPDATE_NODE](state, action) {
    const { node } = action

    if (!node) return state
    if (node.user !== state.data.ticketId) return state

    const index = state.data.nodeInfos.findIndex((item) => item._id === node._id)
    state.data.nodeInfos[index] = node

    if (node?.isRemoved){
      state.data.nodeInfos[index].actionDetailList = []
      state.data.nodeInfos[index].messageContent = {
        messageText: 'comment_delete',
        attachments: [],
        buttons: [],
      }
    }

    return {
      ...state,
      data: {
        ...state.data,
        nodeInfos: [...state.data.nodeInfos],
      },
    }
  },
  [types.WALL_FETCH_REQUEST](state, action) {
    return { ...state, isFetchingWalls: true, data: { ...state.data, nodeInfos: [] } }
  },
  [types.WALL_FETCH_SUCCESS](state, action) {
    return {
      ...state,
      data: action.wall,
      isFetchingWalls: false,
    }
  },
  [types.WALL_ADD_POST_REQUEST](state) {
    return {
      ...state,
      isSendingEvent: true,
    }
  },
  [types.WALL_ADD_POST_SUCCESS](state) {
    return {
      ...state,
      isSendingEvent: false,
    }
  },
  [types.WALL_ADD_EVENT_REQUEST](state) {
    return {
      ...state,
      isSendingEvent: true,
    }
  },
  [types.WALL_ADD_EVENT_SUCCESS](state, action) {
    const index = state.data.nodeInfos.findIndex((item) => item._id === action.node._id)
    state.data.nodeInfos[index] = action.node
    return {
      ...state,
      data: {
        ...state.data,
        nodeInfos: [...state.data.nodeInfos],
      },
    }
  },
})
